export default function DesktopLayout({ sidebar, topbar, content, aside }) {
  return (
    <div className="hidden md:flex w-full h-full">
      <div className="flex-shrink-0">{sidebar}</div>

      <div className="flex flex-col flex-1 min-w-0">
        {topbar}
        <div className="flex flex-1 overflow-y-hidden overflow-x-visible">
          {content}
        </div>
      </div>

      {aside}
    </div>
  );
}
